import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, Container } from 'reactstrap';
import classNames from 'classnames';
import { Image } from '@bottomless/common/components';
import { QuizHeader } from './QuizHeader';
import { QuestionText } from './QuestionText';

const answers = [
  {
    name: 'Light',
    value: 'roast:light',
    explanation: 'Acidic & Bright',
    icon: '/assets/quiz_1_light.png?w=50',
    event: {
      roast: 'light',
    },
  },
  {
    name: 'Medium',
    value: 'roast:medium',
    explanation: 'Balanced & Sweet',
    icon: '/assets/quiz_2_medium.png',
    event: {
      roast: 'Medium',
    },
  },
  {
    name: 'Dark',
    value: 'roast:dark',
    explanation: 'Smoky & Bold',
    icon: '/assets/quiz_1_dark.png',
    event: {
      roast: 'dark',
    },
  },
  {
    name: 'Espresso',
    value: 'roast:espresso',
    explanation: 'Rich & Syrupy',
    icon: '/assets/quiz_1_espresso.png',
    event: {
      roast: 'espresso',
    },
  },
];

export const Question1 = ({ index, total, displayIndex, displayTotal, onAnswer, answers: quizAnswers, isMobile }) => {
  return (
    <>
      <QuizHeader index={displayIndex} total={displayTotal} />
      <QuestionText
        index={index}
        total={total - 1}
        title="Roast Level"
        subtitle="What kind of cup sounds best to you?"
      />
      <Container className="mt-4 px-0">
        <Row className="quiz-answer-row">
          {answers.map((answer, i) => (
            <Col key={i} xs="12" sm="6" lg="3" className="quiz-answer-col">
              <Card
                body
                tag="button"
                className={classNames(
                  'd-flex flex-md-row flex-column align-items-center justify-content-center w-100 answer',
                  {
                    'answer-selected': quizAnswers?.[index] === answer.value,
                  }
                )}
                onClick={() => onAnswer(answer)}
              >
                {quizAnswers?.[index] === answer.value && <span className="quiz-answer-check">✓</span>}
                <Image src={answer.icon} width="50" alt={`Answer - ${answer.name}`} />
                <p
                  className={classNames('mb-0', {
                    'ml-4': !isMobile,
                    'mt-2': isMobile,
                  })}
                >
                  {answer.name}
                </p>
              </Card>
              <p className="quiz-answer-subtext">{answer.explanation}</p>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
};

Question1.propTypes = {
  index: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  displayIndex: PropTypes.number.isRequired,
  displayTotal: PropTypes.number.isRequired,
  onAnswer: PropTypes.func.isRequired,
  answers: PropTypes.object,
  isMobile: PropTypes.bool.isRequired,
};
